import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberLoginPage from "@/pages/member/MemberLoginPage";

export const Route = createFileRoute("/member/login")({
  head: () => pageHead("Member Sign In", "AI Innovation Network member portal sign-in.", "/member/login", true),
  component: MemberLoginPage,
});
